export const buildInfo: { gitHash: string; dateTime: number | 'local' } = { gitHash: '120db6e', dateTime: 1776457700379 };